// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ClaimInt64StringKeyValuePair } from './claimInt64StringKeyValuePair';
import type { Moment } from 'moment';
import type { RequestFile } from '@trialcard/shared';

export class MedicalClaimSearchModel {
    'abfEobNumbers': Array<string>;
    'serviceLineNumber'?: number;
    'eobId'?: number;
    'ids': Array<number>;
    'claimGroupIds': Array<number>;
    'parentClaimIds': Array<number>;
    'memberNumbers': Array<string>;
    'claimStatusIds': Array<number>;
    'paymentTypeIds': Array<number>;
    'externalReferences': Array<ClaimInt64StringKeyValuePair>;
    'isInPaymentBatch'?: boolean;
    'promotionId'?: number;
    'requestedPaymentTypeId'?: number;
    'processorId'?: number;
    'conditionTypeId'?: number;
    'conditionIsOpen'?: boolean;

    static discriminator: string | undefined = undefined;

    static additionalProperties = false;

    static attributeTypeMap: Array<{ name: string; baseName: string; type: string }> = [
        {
            "name":     "abfEobNumbers",
            "baseName": "abfEobNumbers",
            "type":     ""
        },
        {
            "name":     "serviceLineNumber",
            "baseName": "serviceLineNumber",
            "type":     "number"
        },
        {
            "name":     "eobId",
            "baseName": "eobId",
            "type":     "number"
        },
        {
            "name":     "ids",
            "baseName": "ids",
            "type":     ""
        },
        {
            "name":     "claimGroupIds",
            "baseName": "claimGroupIds",
            "type":     ""
        },
        {
            "name":     "parentClaimIds",
            "baseName": "parentClaimIds",
            "type":     ""
        },
        {
            "name":     "memberNumbers",
            "baseName": "memberNumbers",
            "type":     ""
        },
        {
            "name":     "claimStatusIds",
            "baseName": "claimStatusIds",
            "type":     ""
        },
        {
            "name":     "paymentTypeIds",
            "baseName": "paymentTypeIds",
            "type":     ""
        },
        {
            "name":     "externalReferences",
            "baseName": "externalReferences",
            "type":     ""
        },
        {
            "name":     "isInPaymentBatch",
            "baseName": "isInPaymentBatch",
            "type":     "boolean"
        },
        {
            "name":     "promotionId",
            "baseName": "promotionId",
            "type":     "number"
        },
        {
            "name":     "requestedPaymentTypeId",
            "baseName": "requestedPaymentTypeId",
            "type":     "number"
        },
        {
            "name":     "processorId",
            "baseName": "processorId",
            "type":     "number"
        },
        {
            "name":     "conditionTypeId",
            "baseName": "conditionTypeId",
            "type":     "number"
        },
        {
            "name":     "conditionIsOpen",
            "baseName": "conditionIsOpen",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalClaimSearchModel.attributeTypeMap;
    }
}
